(function () {
  console.log("[Disclosure Init] Starting global disclosure initialization...");

  var initialized = [];
  var initAttempts = 0;
  var maxAttempts = 50;

  function initializeAllDisclosures(skipMobileMenu) {
    initAttempts++;
    console.log("[Disclosure Init] Attempt #" + initAttempts);

    if (!window.theme || !window.theme.Disclosure) {
      console.warn(
        "[Disclosure Init] theme.Disclosure not available yet, retrying..."
      );
      if (initAttempts < maxAttempts) {
        setTimeout(function () {
          initializeAllDisclosures(skipMobileMenu);
        }, 100);
      } else {
        console.error(
          "[Disclosure Init] Failed after " + maxAttempts + " attempts"
        );
      }
      return;
    }

    console.log("[Disclosure Init] theme.Disclosure is available!");

    // Find ALL disclosure elements in the page (including hidden ones)
    var allDisclosures = document.querySelectorAll(
      "[data-disclosure-locale], [data-disclosure-currency]"
    );
    console.log(
      "[Disclosure Init] Found " +
        allDisclosures.length +
        " disclosure elements"
    );

    allDisclosures.forEach(function (element, index) {
      // Skip mobile menu disclosures on initial load (will init when menu opens)
      var inMobileMenu = element.closest(".mrMenuDrawer");
      if (skipMobileMenu && inMobileMenu) {
        console.log(
          "[Disclosure Init] Skipping mobile menu disclosure on initial load #" +
            index
        );
        return;
      }

      // Skip if element already has event listeners attached
      if (element.__disclosureInitialized) {
        console.log(
          "[Disclosure Init] Skipping already initialized element #" + index
        );
        return;
      }

      var elementId =
        element.getAttribute("data-disclosure-locale") !== null
          ? "locale"
          : "currency";
      var parentId = element.closest("[data-section-id]")
        ? element.closest("[data-section-id]").getAttribute("data-section-id")
        : inMobileMenu
        ? "mr-menu"
        : element.closest(".secondary-announcement")
        ? "secondary-announcement"
        : "unknown";

      var uniqueKey = parentId + "-" + elementId;

      console.log(
        "[Disclosure Init] Initializing disclosure #" + index + ": " + uniqueKey
      );
      try {
        new theme.Disclosure(element);
        element.__disclosureInitialized = true;
        initialized.push(uniqueKey);
        console.log(
          "[Disclosure Init] ✓ Successfully initialized: " + uniqueKey
        );
      } catch (error) {
        console.error(
          "[Disclosure Init] ✗ Failed to initialize " + uniqueKey + ":",
          error
        );
      }
    });

    console.log(
      "[Disclosure Init] Initialization complete. Total initialized: " +
        initialized.length
    );
  }

  // Start initialization - skip mobile menu on initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeAllDisclosures(true); // true = skip mobile menu
    });
  } else {
    initializeAllDisclosures(true); // true = skip mobile menu
  }

  // Re-initialize when mobile menu opens - watch for class changes
  var menuObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        var target = mutation.target;
        // Check if mr-menu drawer just opened
        if (
          target.classList &&
          target.classList.contains("mrMenuDrawer") &&
          target.classList.contains("is-open")
        ) {
          console.log(
            "[Disclosure Init] Mobile menu opened, re-initializing disclosures..."
          );
          // Wait a bit longer for DOM to settle
          setTimeout(function () {
            // Find disclosures specifically inside the opened menu
            var menuDisclosures = target.querySelectorAll(
              "[data-disclosure-locale], [data-disclosure-currency]"
            );
            console.log(
              "[Disclosure Init] Found " +
                menuDisclosures.length +
                " disclosures in mobile menu"
            );

            menuDisclosures.forEach(function (element) {
              if (!element.__disclosureInitialized) {
                console.log(
                  "[Disclosure Init] Initializing mobile menu disclosure..."
                );
                try {
                  new theme.Disclosure(element);
                  element.__disclosureInitialized = true;
                  console.log(
                    "[Disclosure Init] ✓ Mobile menu disclosure initialized"
                  );
                } catch (error) {
                  console.error(
                    "[Disclosure Init] ✗ Failed to initialize mobile menu disclosure:",
                    error
                  );
                }
              } else {
                console.log(
                  "[Disclosure Init] Mobile menu disclosure already initialized"
                );
              }
            });
          }, 150);
        }
      }
    });
  });

  // Start observing the mr-menu drawer
  setTimeout(function () {
    var mrMenuDrawer = document.querySelector(".mrMenuDrawer");
    if (mrMenuDrawer) {
      console.log(
        "[Disclosure Init] Watching mobile menu for state changes..."
      );
      menuObserver.observe(mrMenuDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    } else {
      console.warn("[Disclosure Init] Mobile menu drawer not found");
    }
  }, 500);

  // Shopify theme editor support
  document.addEventListener("shopify:section:load", function () {
    console.log("[Disclosure Init] Section loaded, re-initializing...");
    setTimeout(function () {
      initializeAllDisclosures(false);
    }, 200); // false = don't skip anything
  });
})();
